/** What each document's tick box says; the document itself is behind the link. */
export const LEGAL_DOCUMENT_LABEL = {
    terms: { before: 'I agree to the ', link: 'Terms of Service' },
    privacy: { before: 'I have read the ', link: 'Privacy Policy' },
};
/** The email notice choice (16 CFR 318.5: email counts as notice only when chosen as primary). */
export const NOTICE_CHANNEL_LABEL = 'Send notices about my account, including security notices, to my email address.';
/** A date in the person's own time zone (DS-CONTENT-04). */
export function longDate(iso) {
    return new Date(iso).toLocaleDateString(undefined, { dateStyle: 'long' });
}
//# sourceMappingURL=copy.js.map